<template>
  <div class="content">
    <breadcrumb
      :items="pagecrumbs"
      :is-seo-page="true"
    />
    <header-responsive
      :header-background="`//${cdn}/assets/categories/agenturen.jpg`"
      header-title-html="distribution:destination.workWithDestinations"
      header-subtitle-html="distribution:destination.decideForSolution"
      :header-links="linksHeader"
    />
    <div class="container">
      <p>{{ $t('distribution:destination.introText') }}</p>
      <agency-and-destination-image-part
        main-headline="distribution:destination.headline"
        :benefits="destinationBenefits"
        benefits-cols="col-md-3"
        :workflow-texts="{contractualText: 'destination.workflow.contractualTxt', actitvationText:'destination.workflow.activationTxt'}"
        work-flow-headline="distribution:agency.howItWorks"
        page-key="destination"
      />
      <h3>
        {{ $t('distribution:destination.distributionModels') }}
      </h3>
      <div
        v-for="(explanationSystem, explanationIndex) in explanationSystems"
        :key="explanationIndex"
      >
        <div class="mt-3">
          <strong>{{ $t(`distribution:destination.systems.${explanationSystem.headline}`) }}</strong>
        </div>
        <p>{{ $t(`distribution:destination.systems.${explanationSystem.text}`) }}</p>
        <span>
          {{ $t('distribution:destination.benefits') }}
        </span>
        <ul>
          <li
            v-for="(listItem, listItemnIndex) in explanationSystem.listItems"
            :key="listItemnIndex"
          >
            {{ $t(`distribution:destination.systems.${listItem}`) }}
          </li>
        </ul>
        <logo-list
          :logo-list-data="explanationSystem.images"
        />
      </div>
      <section class="contact">
        <h3>{{ $t('distribution:agency.contact') }}</h3>
        <office-contact
          :template="'officeContactCard'"
        />
      </section>
      <content-text-teaser
        :teaser-elements="teaserLearnMore"
        teaser-variant="dark"
      />
    </div>
  </div>
</template>

<script>
import Breadcrumb from 'components/Breadcrumb.vue';
import HeaderResponsive from 'components/HeaderResponsive.vue';
import { logosWithoutSystem, logosWithSystem } from 'config/logoListConfig';
import OfficeContact from 'components/OfficeContact.vue';
import ContentTextTeaser from 'components/ContentTextTeaser.vue';
import AgencyAndDestinationImagePart from 'components/AgencyAndDestinationImagePart.vue';
import LogoList from 'components/LogoList.vue';
import cdn from 'config/cdn';

export default {
  name: 'Destination',
  i18nOptions: { namespaces: 'distribution' },
  components: {
    Breadcrumb,
    HeaderResponsive,
    OfficeContact,
    ContentTextTeaser,
    AgencyAndDestinationImagePart,
    LogoList,
  },
  data() {
    return {
      cdn,
      destinationBenefits: [
        { headline: 'highQualityPresentation', bulletins: ['attractivePresentation', 'modernAndResponsive', 'seoOptimized'] },
        { headline: 'distriNetwork', bulletins: ['nationalRooted', 'globalConnected'] },
        { headline: 'bookability', bulletins: ['twentyfourHours', 'sevenDays', 'allYear'] },
        { headline: 'moreEfficiency', bulletins: ['moreDirectReservation', 'minimizedHassle'] },
      ],
    };
  },
  computed: {
    pagecrumbs() {
      return [
        { label: 'distribution:destination.name' },
      ];
    },
    linksHeader() {
      return [
        {
          teaser: 'distribution:headerLinks.agencies.teaser', title: 'distribution:headerLinks.agencies.title', primary: true, href: 'distribution:headerLinks.agencies.link', target: '_blank',
        },
      ];
    },
    explanationSystems() {
      return [
        {
          headline: 'withoutReservation.headline',
          text: 'withoutReservation.text',
          listItems: [
            'withoutReservation.noSystemFees',
            'withoutReservation.internationalDistri',
            'noInstallationFees',
            'withoutReservation.billingOnSuccess',
          ],
          images: logosWithoutSystem,
        },
        {
          headline: 'withReservation.headline',
          text: 'withReservation.text',
          listItems: [
            'withReservation.options',
            'noInstallationFees',
            'withReservation.easyToInstall',
          ],
          images: logosWithSystem,
        },
      ];
    },
    teaserLearnMore() {
      return [
        {
          head: 'distribution:travelAgency.teaserLearnMore.agency.head',
          href: { name: 'Agency' },
          html: 'distribution:travelAgency.teaserLearnMore.agency.html',
          title: 'distribution:travelAgency.teaserLearnMore.agency.title',
        },
        {
          head: 'distribution:travelAgency.teaserLearnMore.retailer.head',
          href: { name: 'Retailer' },
          html: 'distribution:travelAgency.teaserLearnMore.retailer.html',
          title: 'distribution:travelAgency.teaserLearnMore.retailer.title',
        },
      ];
    },
  },
};
</script>
